import React, { ReactNode } from "react";
interface FormDirectionsProps {
    children: ReactNode;
}

const FormDirections = ({ children }: FormDirectionsProps) => {
    return (
        <div className="directions">
            {children}
        </div>
    );
}

export default FormDirections;